import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { EnquiryComponent } from '../enquiry.component';
import { NxDialogService, NxModalRef } from '@aposin/ng-aquila/modal';
import { FormBuilder, FormGroup } from "@angular/forms";
import { Select, Store } from '@ngxs/store';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { GET_ENQUIRY_DETAILS } from '@store/enquiry/enquiry.action';
import moment from 'moment';
import { SatMotorState } from '@store/sat-motor/sat-motor.state';
import { Observable } from 'rxjs';
import { UserResponse } from '@interfaces/user';
import { CALCULATE_ENDT_PREMIUM, CALCULATE_PREMIUM, CALCULATE_PREMIUM_SUMMARY, CANCEL_COVER_NOTE, CANCEL_QUOTATION, CANCEL_REPLACE, COPY_CNGE_INFO, COPY_CNGE_INFO_VIEW_QUOTATION, COPY_CNGE_TO_ENDORSEMENT_STATE, DOWNLOAD_PDF, ENDT_CALCULATE_PREMIUM_SUMMARY, ENDT_SET_UPDATE_PAYMENT_DATA, GENERATE_ENDORSEMENT, GET_CCENTRIC_ENDT_OPPORTUNITY_INFO, GET_CCENTRIC_OPPORTUNITY_INFO, GET_CHECKLIST_LOV, GET_DOCUMENT_LOV, GET_PRODUCT_LIST, GET_QUOTATION_DETAIL, GET_QUOTATION_DETAIL_ENDT, GET_QUOTATION_DETAIL_REQUOTE, GET_SWITCH_SITE, RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ, SAVE_REFERRAL_REMARKS, SEARCH_ENDT_VEHICLE, SEARCH_ORIXCompanyInfo, SET_ACTION, SET_IS_CREATED_BY_CC_USER, SET_OPPORTUNITY_ID, SET_UPDATE_PAYMENT_IND, UPDATE_QUOTATION_GET_CCENTRIC_OPPORTUNITY_INFO, GET_NCD_ENQUIRY, VIEW_ENDT_CALCULATE_PREMIUM, ENDT_GET_UPDATE_QUOTATION_DETAILS } from '@store/sat-motor/sat-motor.action';
import { firstValueFrom } from 'rxjs';
import { CoverageSummaryComponent } from '@shared/components/coverages/coverage-summary/coverage-summary.component';
import { ViewRemarksComponent } from '@shared/components/view-remarks/view-remarks.component';
import { RequestCancellationComponent } from '@shared/components/modal/request-cancellation/request-cancellation.component';
import { ACTIONS } from '@shared/enums/index.enum';
import { OkMessageComponent } from '@shared/components/modal/ok-message/ok-message.component';
import { ClauseMessageComponent } from '@shared/components/modal/clause-message/clause-message.component';
import { UploadDocumentComponent } from '@shared/components/upload-document/upload-document.component';
import { EmailDocumentComponent } from '@shared/components/modal/email-document/email-document.component';
import { ChecklistComponent } from '@shared/components/checklist/checklist.component';
import { EndorsementNarrationComponent } from '@shared/components/endorsement-narration/endorsement-narration.component';
import { RemarksComponent } from '@shared/components/modal/remarks/remarks.component';
import { PaymentComponent } from '@shared/components/payment/payment.component';
import { ViewRoadTaxPayableComponent } from '@shared/components/view-road-tax-payable/view-road-tax-payable.component';
import { PaymentInformationComponent } from '@shared/components/payment-information/payment-information.component';
import { PaymentDetailsComponent } from '@shared/components/payment-details/payment-details.component';
import { AccessConfig, ButtonAccessConfig } from '@shared/helpers/sat-menu-access-config';
import { MenuAccessService } from '@shared/services/sat-menu-access/menu-access.service';

@Component({
  selector: 'app-view-endorsement',
  standalone: true,
  imports: [
    EnquiryComponent,
    SharedModule,
    CoverageSummaryComponent,
    ViewRemarksComponent,
    ChecklistComponent,
    EndorsementNarrationComponent,
    PaymentComponent,
    ViewRoadTaxPayableComponent,
    PaymentInformationComponent,
    PaymentDetailsComponent
  ],
  templateUrl: './view-endorsement.component.html',
  styleUrl: './view-endorsement.component.scss'
})
export class ViewEndorsementComponent implements OnInit {
  
  @Select(SatMotorState.commonLov) commonLov$;
  requestCancellationModal?: NxModalRef<RequestCancellationComponent>;
  okMessageModal?: NxModalRef<OkMessageComponent>;
  clauseMsgModal?: NxModalRef<ClauseMessageComponent>;
  dialogRef?: NxModalRef<any>;
  emailDocumentModal?: NxModalRef<EmailDocumentComponent>;
  remarksModal?: NxModalRef<RemarksComponent>;

  @ViewChild("tmplEndtNotExist") endtNotExist!: TemplateRef<any>;
  
  enquiryDetail: any;
  type: any;
  viewProductTitle: any;
  popupMessage: any;
  referralReasonList: any;
  status: any;
  coverNoteText: any;
  agentData: any;
  progressType: any;
  issuanceInfo: any;
  cpData: any;
  premiumInfo: any;
  claimList: any;
  endorsementHistoryList: any;
  checkListItems: any;
  checklistNote: any;
  checklistRemark: any;
  remarksInfo: any; 
  agentInfo: any;
  payment: any;
  paymentList: any;
  roadTaxPayable: any;
  paymentInformation: any;
  htgePol: any;
  opportunityId: any;

  viewQuotation: boolean = false;
  isEndorsement: boolean = false;
  isDataLoaded: boolean = false;
  queryParams: any = {};
  userInfo: any = {};
  lov: any;
  showRemarks: boolean = false;
  cngeNote: any;
  responseData: any;
  classType: any;
  proposalNo: any;
  coverageInfo: any;
  clientClaimHistory: any;
  vehicleClaimHistory: any;
  productList: any;
  endorsementList: any;
  productName: any;
  endtPolicy: any;
  checklistLov: any;
  endtCode: any;
  latestPremiumCalculation: any;
  viewForm: FormGroup;
  isCCentric: boolean = false;
  isCreatedByCcUser: boolean = false;

  showAgentInfo: boolean = false;
  showIssuanceInfo: boolean = false;
  showCustomerPartner: boolean = false;
  showReferralDetails: boolean = false;
  showCoverage: boolean = false;
  showHistoricalClaim: boolean = false;
  showPremiumInformation: boolean = false;
  showReferCase: boolean = false;
  showPayment: boolean = false;
  showUpsellProduct: boolean = false;
  showPaymentInformation: boolean = false;
  showPaymentDetails: boolean = false;
  showChecklist: boolean = false;
  showRenewalAssistant: boolean = false;
  showEndorsementNarration: boolean = false;
  showRoadTaxPayable: boolean = false;
  showEndorsementErrMessage: boolean = false;

  isShowBackBtn: boolean = false;
  isShowRequestCancellationBtn: boolean = false;
  isShowUpdateQuotationBtn: boolean = false;
  isShowSendToJPJBtn: boolean = false;
  isShowUploadDocumentBtn: boolean = false;
  isShowAddRemarksBtn: boolean = false;
  isUpdatePaymentBtn: boolean = false;
  isShowDownloadQuotationBtn: boolean = false;
  isShowDownloadCoverNoteBtn: boolean = false;
  isShowDownloadCertificateBtn: boolean = false;
  isShowDownloadInvoiceBtn: boolean = false;
  isShowDownloadCreditInvoiceBtn: boolean = false;
  isShowDownloadDebitInvoiceBtn: boolean = false;
  isShowUpdateJPJBtn: boolean = false;
  isShowAmendCoverNoteBtn: boolean = false;
  isShowEmailDocumentBtn: boolean = false;
  isShowRequoteBtn: boolean = false;
  isShowMarketingBtn: boolean = false;
  isShowIssueNewBtn: boolean = false;
  isDisableInvoiceButton: boolean = true;
  isDisableCreditInvoiceButton: boolean = true;
  isDisableDebitInvoiceButton: boolean = true;

  statusMap = {
    PRINTED: "Printed",
    APPROVED: "Approved",
    PENDING: "Pending Approval",
    CANCELLED: "Cancelled",
    SUBMITTED: "Submitted",
    ACTIVE: "Active",
    EXPIRED: "Expired"
  };

  classTypeMap = {
    PRINTED: "printed_badge",
    APPROVED: "approved_badge",
    PENDING: "pending_badge",
    CANCELLED: "cancel_badge",
    SUBMITTED: "submitted_badge",
    ACTIVE: "active_badge",
    EXPIRED: "expired_badge"
  };

  @Select(SatMotorState.premiumCalculationSummary) premiumCalculationSummary$: Observable<SatMotorState>;
  
  constructor(
    private dialogService: NxDialogService,
    public store: Store,
    private router: Router,
    private fb: FormBuilder,
    private accessService: MenuAccessService
  ) {}

  async ngOnInit() {

    window.scroll({ top: 0, left: 0, behavior: 'instant' });
    this.queryParams = this.store.selectSnapshot<any>((state) => state.UserState.queryParams);
    this.userInfo = this.store.selectSnapshot<UserResponse>(state => state.UserState.user);
    this.isEndorsement = true;
    this.isCCentric = this.queryParams.opportunityId;
    this.opportunityId = this.store.selectSnapshot<any>(state => state.SatMotorState.opportunityId);

    this.viewForm = this.fb.group({
      checklistForm: new FormGroup({}),
    });

    this.commonLov$.subscribe((state) => {
      if (state) {
        this.lov = state;
      }
    });

    if(this.isCCentric) {
      await this.searchEndorsementByOpportunityId();
    }else {
      await this.searchEndorsementByContractId();
    }

    this.store.dispatch(new GET_CHECKLIST_LOV(this.cngeNote.endtCode)).subscribe(state => {
      this.checklistLov = state.SatMotorState.checklistLov;
    });

    this.type = 'view-endorsement-enquiry';
  }

  searchEndorsementByContractId(contractId?) {
    let contractIdPayload = contractId ? contractId : this.queryParams.contractId;

    return new Promise((resolve) => {
      this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(contractIdPayload, "SUMMARY")).subscribe((state) => {
        this.populateCommonData(state, null);

        if (this.userInfo.callCenter) {
          this.agentInfo = state.SatMotorState.viewQuotation.mkagAgent; 

          let endtPremiumCalculationPayload = {
              ...state.SatMotorState.viewQuotation,
              riskList: [{
                ...state.SatMotorState.viewQuotation.riskList[0],
                coverList: [{
                  ...state.SatMotorState.viewQuotation.riskList[0].coverList[0],
                  coverDto: {
                    ...state.SatMotorState.viewQuotation.riskList[0].coverList[0].coverDto,
                    checkPremCalc: false
                  }
                }]
              }],
          };

          this.store.dispatch(new VIEW_ENDT_CALCULATE_PREMIUM({
             cngeNoteDto: endtPremiumCalculationPayload, 
             htgePol: this.htgePol,
             operator: this.userInfo.userId 
            })).subscribe(state => {
            let premiumResponse = state.SatMotorState.summaryPremium;
            this.getPaymentData(premiumResponse);
          });
        }

        this.showRemarks = !!this.remarksInfo;
        this.showComponents();
        this.getDocumentListLov();
        this.updateButtons(this.cngeNote, this.issuanceInfo.issuance);
        window.scroll({ top: 0, left: 0, behavior: 'instant' });
        resolve(true);
      });
    });
  }

  searchEndorsementByOpportunityId() {
    const param = {
      "opportunityId": this.queryParams.opportunityId,
      "action": "SUMMARY"
    };

    return new Promise((resolve) => {
      this.store.dispatch(new GET_CCENTRIC_ENDT_OPPORTUNITY_INFO(param)).subscribe((state) => {
        this.agentInfo = state.SatMotorState.viewQuotation.mkagAgent;

        this.populateCommonData(state, null);

        let calculatePremiumPayload = state?.SatMotorState?.viewQuotation;
        if (calculatePremiumPayload?.riskList[0]?.coverList[0]?.subCovPackage) {
          calculatePremiumPayload = {
            ...calculatePremiumPayload,
            riskList: [
              {
                ...calculatePremiumPayload.riskList[0],
                coverList: [
                  {
                    ...calculatePremiumPayload.riskList[0].coverList[0],
                    coverDto: {
                      ...calculatePremiumPayload.riskList[0].coverList[0].coverDto,
                      extCovPackageSelected: calculatePremiumPayload.riskList[0].coverList[0].subCovPackage
                    }
                  }
                ]
              }
            ]
          };
        }

        this.store.dispatch(new VIEW_ENDT_CALCULATE_PREMIUM({ 
          cngeNoteDto: calculatePremiumPayload, 
          htgePol: this.htgePol,
          operator: this.userInfo.userId 
        })).subscribe(state => {
          this.latestPremiumCalculation = state.SatMotorState.summaryPremium;
          let latestCoveragePremium = state?.SatMotorState?.summaryPremium?.riskList?.[0].coverList?.[0];
          let hasSubCovPackageList = latestCoveragePremium?.coverDto?.subCovPackageList;
          let previousSubCoverList = this.store.selectSnapshot<any>((state) => state.SatMotorState?.viewQuotation?.riskList?.[0].coverList?.[0].subCoverList);
          let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0);



          if (hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
            let latestSubCovList = latestCoveragePremium?.coverDto?.subCovList;

            if (hasWaiver) {
              latestSubCovList = latestSubCovList?.map(obj => {
                if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
                  return { ...obj, selected: true }
                }
                return obj;
              })
            }

            calculatePremiumPayload = {
              ...calculatePremiumPayload,
              riskList: [{
                ...calculatePremiumPayload.riskList[0],
                coverList: [{
                  ...calculatePremiumPayload.riskList[0].coverList[0],
                  coverDto: {
                    ...calculatePremiumPayload.riskList[0].coverList[0].coverDto || {},
                    subCovList: latestSubCovList || [],
                    subCovPackageList: hasSubCovPackageList
                  }
                }]
              }]
            };

            this.store.dispatch(new VIEW_ENDT_CALCULATE_PREMIUM({
              cngeNoteDto: calculatePremiumPayload,
              htgePol: this.htgePol,
              operator: this.userInfo.userId
            })).subscribe(state => {

              let premiumResponse = state.SatMotorState.summaryPremium;
              this.latestPremiumCalculation = state.SatMotorState.summaryPremium;

              this.premiumInfo = {
                ...this.premiumInfo,
                premiumDueRounded: premiumResponse.cCentrixPremiumDueRounded ?? this.premiumInfo.premiumDueRounded
              };
              this.getPaymentData(premiumResponse);
            });
          } else {
            let premiumResponse = state.SatMotorState.summaryPremium;
            this.latestPremiumCalculation = state.SatMotorState.summaryPremium;
            // this.premiumInfo = {
            //   ...this.premiumInfo,
            //   premiumDueRounded: premiumResponse.cCentrixPremiumDueRounded ?? this.premiumInfo.premiumDueRounded
            // };
            this.getPaymentData(premiumResponse);
          }
        });

        this.showRemarks = !!this.remarksInfo;
        this.showComponents();
        this.getDocumentListLov();
        this.updateButtons(this.cngeNote, this.issuanceInfo.issuance);
        window.scroll({ top: 0, left: 0, behavior: 'instant' });
        resolve(true);
      });
    });
  }

  getDocumentListLov() {
    this.store.dispatch(new GET_DOCUMENT_LOV({
      lob: "MT",
      userId: this.userInfo.userId,
      productCode: this.endtPolicy.productCode,
      productType: "",
      type: 'SATMTCNDOCTYPE'
    }));
  }

  populateCommonData(state: any, sendJPJResponse: any) {
    this.endtPolicy = state.SatMotorState.viewQuotation;
    this.responseData = state.SatMotorState.viewQuotationData;
    this.cngeNote = this.responseData.cngeNote;
    this.status = this.statusMap[this.cngeNote.cnoteStatus] || "";
    this.classType = this.classTypeMap[this.cngeNote.cnoteStatus] || "";
    this.proposalNo = sendJPJResponse ? sendJPJResponse.cnoteNo : this.cngeNote.proposalNo || this.cngeNote.cnoteNo;
    this.htgePol = state.SatMotorState?.viewHtgePol;
  
    if(this.cngeNote.oppurtunityId) {
      this.opportunityId = this.cngeNote.oppurtunityId;
      this.store.dispatch(new SET_OPPORTUNITY_ID(this.cngeNote.oppurtunityId));
    }

    if(this.cngeNote?.createdByCcUser) {
      this.isCreatedByCcUser = this.cngeNote.createdByCcUser;
      this.store.dispatch(new SET_IS_CREATED_BY_CC_USER(this.cngeNote.createdByCcUser));
    }

    this.agentData = this.responseData.agentData;
    this.issuanceInfo = this.responseData.issuanceInfo;
    this.cpData = this.responseData.cpData;
    this.coverageInfo = { ...this.responseData.coverageInfo };
    this.coverageInfo.coverageDetails = {
      ...this.coverageInfo.coverageDetails,
      avInd: this.endtPolicy.riskList[0].avInd
    };
    this.coverageInfo.vehicleDetails = {
      ...this.coverageInfo.vehicleDetails,
      buyerOverwriteInd: this.cngeNote.buyerOverwriteInd,
      leasCompCode: this.responseData.cngeNote.leasCompCode
    };

    //this.premiumInfo = this.responseData.premiumInfo;
    this.premiumInfo = {
      ...this.responseData.coverList,
      stamp: this.endtPolicy.stamp,
      premiumDue: this.endtPolicy.premiumDue,
      premiumDueRounded: this.endtPolicy.premiumDueRounded
    }

    if(this.opportunityId || this.isCreatedByCcUser) {
      this.premiumInfo.premiumDueRounded = this.responseData.premiumInfo.cCentrixPremiumDueRounded;
    }

    this.remarksInfo = this.responseData.remarksInfo;
  
    this.clientClaimHistory = this.cngeNote.claimCnt ?? '0';
    this.vehicleClaimHistory = this.cngeNote.vehClaimCount ?? '0';
  
    this.updateProductList(this.responseData.mkagAgent.agentCode, this.cngeNote.productCode);
    this.lov = this.store.selectSnapshot<any>((state) => state.SatMotorState.lov);

    this.setStatusMessage(this.endtPolicy.cnoteStatus);
    this.setReferralCode(this.cngeNote.referList)

    if (this.coverageInfo.vehicleDetails.vehicleLoanCompany === 'ORIX'){
    this.store.dispatch(new SEARCH_ORIXCompanyInfo({ agentCode: this.responseData.mkagAgent.agentCode, 
      loanCompany: this.responseData.riskList[0].vehicleLoanCompany, loanType: this.responseData.riskList[0].vehicleLoanType, 
      vehType: this.cngeNote.productCode, eInvoiceInd: this.responseData.issuanceInfo.pdpa.consentDetails.einvoiceConsentInd}));
    }
  }

  setReferralCode(referList: any) {
    if(referList && referList.length > 0) {
      this.referralReasonList = referList;
    } else {
      this.referralReasonList = [];
    }
  }

  setStatusMessage(status) {
    if (status === 'PENDING') {
      this.popupMessage = 'Your e-Cover Note has been submitted as pending approval.';
    } else if (status === 'CANCELLED') {
      this.popupMessage = 'Endorsement has been cancelled successfully.';
    } else {
      this.popupMessage = null;
    }
    
  }

  async updateProductList(agentCode, productCode) {
    this.productList = this.lov?.productList;
    if (!this.productList) {
      let productListPayload = {
        lob: 'MT',
        agentCode: agentCode
      };

      await firstValueFrom(this.store.dispatch(new GET_PRODUCT_LIST(productListPayload)));
      const updatedLov = this.store.selectSnapshot<any>(state => state.SatMotorState?.lov);
      this.productList = updatedLov.productList;
      this.endorsementList = updatedLov.endorsementList;
    }

    let product = this.productList.find(e => e.code === productCode);
    if (product) {
      let descp = product.descp
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase());
      console.log(this.productList);
      this.productName = {
        descp: descp
      }

      this.viewProductTitle = descp;
    }

    this.getCoverDescription(productCode);
    this.isDataLoaded = true;
  }

  getCoverDescription(productCode) {
    const productAccessConfigList = this.lov?.productAccessConfigList;
    if (!productAccessConfigList) return;

    const coverListLov = productAccessConfigList.reduce((list, product) => {
      return list.concat(product[productCode]?.coverList || []);
    }, []);

    const coverCodeVal = this.coverageInfo?.coverageDetails?.coverCode;

    if (coverCodeVal) {
      const matchingCover = coverListLov.find(cover => cover.coverCode === coverCodeVal);
      if (matchingCover) {
        const updatedCoverageDetails = {
          ...this.coverageInfo.coverageDetails,
          coverDescription: matchingCover.coverDescription
        };

        this.coverageInfo = {
          ...this.coverageInfo,
          coverageDetails: updatedCoverageDetails
        };
      }
    }
  }

  showComponents() {
    this.showAgentInfo = true;
    this.showIssuanceInfo = true;
    this.showCustomerPartner = true;
    this.showCoverage = true;
    this.showHistoricalClaim = true;
    this.showPremiumInformation = true;
    this.viewQuotation = true;
    this.progressType = 'endorsement';

    // this.showPayment = true;
    // this.showPaymentInformation = true;
    // this.showPaymentDetails = true;
    // this.showChecklist = true;
    // this.showEndorsementNarration = true;
    // this.showRoadTaxPayable = true;

    if (this.userInfo.callCenter && this.premiumInfo.premiumDueRounded > 0) { // add the additional premium checking
      this.showPaymentDetails = true;
      this.showPaymentInformation = true;
      this.showPayment = true;
      if (this.cngeNote.cnoteType === "XP") {
        this.showRoadTaxPayable = true;
      }
    }
  }

  updateButtons(cngeNote: any, issuance: any) {
    const status = cngeNote.cnoteStatus;
    const isPendingApproval = status === 'PENDING';
    const isPrintQuotation = status === 'PRINTED' && cngeNote.proposalNo && !cngeNote.cnoteNo;
    const isPrintCNote = status === 'PRINTED' && cngeNote.cnoteNo;
    const isCancelled = status === 'CANCELLED';
    const isSubmitted = status === 'SUBMITTED';

    cngeNote = { ...cngeNote, isPendingApproval, isPrintQuotation, isPrintCNote };
    this.cngeNote = { ...cngeNote };

    this.isShowBackBtn = true; //enabled for all cnoteStatus

    if (isPendingApproval) {
      Object.assign(this, {
        isShowRequestCancellationBtn: this.showRequestCancellation(cngeNote, true),
        isShowAddRemarksBtn: !!this.userInfo.agent && this.userInfo.agent === true,
        isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowUploadDocumentBtn: true,
      });
    } else if (isPrintQuotation) {
      Object.assign(this, {
        isShowRequestCancellationBtn: this.showRequestCancellation(cngeNote, false),
        isShowUpdateQuotationBtn: true,
        isShowDownloadQuotationBtn: true,
        //isShowSendToJPJBtn: !!this.userInfo.agent && this.userInfo.agent === true,
        isShowUploadDocumentBtn: true,
        isShowEmailDocumentBtn: true
      });
    } else if (isPrintCNote) {
      Object.assign(this, {
        isShowRequestCancellationBtn: this.showRequestCancellation(cngeNote, false),
        isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowDownloadCoverNoteBtn: true,
        isShowDownloadCertificateBtn: this.showCertificatePdf(status, cngeNote.cnoteType),
        isShowUploadDocumentBtn: true,
        isShowEmailDocumentBtn: true
      });
      this.updateInvoiceButton(this.endtPolicy);
    } else if (isSubmitted) {
      Object.assign(this, {
        isUpdatePaymentBtn: this.showUpdatePayment(cngeNote),
        isShowDownloadCoverNoteBtn: true,
        isShowDownloadCertificateBtn: this.showCertificatePdf(status, cngeNote.cnoteType),
        isShowUploadDocumentBtn: true,
        isShowEmailDocumentBtn: true,
      });
      this.updateInvoiceButton(this.endtPolicy);
    }else if(isCancelled) {
      Object.assign(this, {
        isShowRequestCancellationBtn: false,
        isShowAddRemarksBtn: false,
        isShowUpdateQuotationBtn: false,
        isUpdatePaymentBtn: false,
        isShowDownloadCoverNoteBtn: false,
        isShowDownloadCertificateBtn: false,
        isShowDownloadInvoiceBtn: false,
        isShowDownloadCreditInvoiceBtn: false,
        isShowDownloadDebitInvoiceBtn: false,
        isShowUploadDocumentBtn: false,
        isShowEmailDocumentBtn: false
      });
    }
  }

  updateInvoiceButton(policy: any) {
    let clientSstRegInd = policy?.clientPartner?.clientSstRegInd ?? null;
    let einvoiceConsentInd = (policy?.hasOwnProperty('einvoiceConsentInd'))
      ? (policy.einvoiceConsentInd === true ? 'Y'
        : (policy.einvoiceConsentInd === false ? 'N' : null)) : null;

    let einvoiceStatus = policy?.einvoiceStatus ?? null;
    let cnoteType = policy.cnoteType;
    let premiumDue = policy.premiumDue;

    //Invoice PDF Checking
    if ((cnoteType === 'EC175' || cnoteType === 'EC176') && einvoiceConsentInd?.trim() === 'Y') {
      this.isShowDownloadInvoiceBtn = true;
      this.checkInvoiceCondition(einvoiceConsentInd, einvoiceStatus);
    } else {
      if (cnoteType !== 'EC175' && cnoteType !== 'EC176') {
        console.log("E-Invoice PDF Button hidden. CnoteType is neither EC175 nor EC176.");
      } else {
        if (!einvoiceConsentInd || einvoiceConsentInd.trim() !== 'Y') {
          console.log(`E-Invoice PDF Button hidden. einvoiceConsentInd is : ${einvoiceConsentInd} `);
        }
      }
    }

    if (cnoteType != 'EC175' && cnoteType != 'EC176') {
      console.log(`premiumDue: ${premiumDue} cnoteType: ${cnoteType} `);

      if (einvoiceConsentInd && einvoiceConsentInd === 'Y') {
        if (premiumDue < 0) {
          //Credit Invoice PDF Checking
          this.isShowDownloadCreditInvoiceBtn = true;
          this.checkCreditInvoiceCondition(einvoiceConsentInd, einvoiceStatus, cnoteType);
        } else {
          console.log(`Credit Tax Button hidden. premiumDue: ${premiumDue}`);
        }
  
        if (premiumDue > 0) {
          //Debit Invoice PDF Checking
          this.isShowDownloadDebitInvoiceBtn = true;
          this.checkDebitInvoiceCondition(einvoiceConsentInd, einvoiceStatus, cnoteType);
        } else {
          console.log(`Debit Tax Button hidden. premiumDue: ${premiumDue}`);
        }
      } else {
        console.log(`Credit Tax and Debit Tax Button hidden. einvoiceConsentInd: ${einvoiceConsentInd}`);
      }
    }
  }

  checkDebitInvoiceCondition(einvoiceConsentInd: string, einvoiceStatus: any, cnoteType: any) {
    const nonPremiumEndorsementTypes = ['ENDT10', 'ENDT12', 'ENDT18', 'EC175', 'EC176'];

    if (nonPremiumEndorsementTypes.includes(cnoteType)) {
      console.log(`Debit Tax Button disabled. Non Premium & E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
    } else {
      if (einvoiceConsentInd) {

        if (einvoiceConsentInd === 'Y' && einvoiceStatus && einvoiceStatus == 'VALID') {
          this.isDisableDebitInvoiceButton = this.validateAccess(AccessConfig.DEBIT_TAX_INVOICE);
        } else if (einvoiceConsentInd === 'N') {
          this.isDisableDebitInvoiceButton = this.validateAccess(AccessConfig.DEBIT_TAX_INVOICE);
        } else {
          console.log(`Debit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
        }

      } else {
        console.log(`Debit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd}`);
      }
    }
  }

  checkCreditInvoiceCondition(einvoiceConsentInd: string, einvoiceStatus: any, cnoteType: any) {
    const nonPremiumEndorsementTypes = ['ENDT10', 'ENDT12', 'ENDT18', 'EC175', 'EC176'];

    if (nonPremiumEndorsementTypes.includes(cnoteType)) {
      console.log(`Credit Tax Button disabled. Non Premium & E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
    } else {
      if (einvoiceConsentInd) {

        if (einvoiceConsentInd === 'Y' && einvoiceStatus && einvoiceStatus == 'VALID') {
          this.isDisableCreditInvoiceButton = this.validateAccess(AccessConfig.CREDIT_TAX_INVOICE);
        } else if (einvoiceConsentInd === 'N') {
          this.isDisableCreditInvoiceButton = this.validateAccess(AccessConfig.CREDIT_TAX_INVOICE);
        } else {
          console.log(`Credit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
        }

      } else {
        console.log(`Credit Tax Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd}`);
      }
    }
  }

  checkInvoiceCondition(einvoiceConsentInd: string, einvoiceStatus: any) {
    if (einvoiceConsentInd) {
      if (einvoiceConsentInd === 'Y' && einvoiceStatus && einvoiceStatus == 'VALID') {
        this.isDisableInvoiceButton = this.validateAccess(AccessConfig.TAX_INVOICE);
      } else {
        console.log(`E-Invoice PDF Button disabled. E-Invoice consent indicator: ${einvoiceConsentInd} IRBM Status: ${einvoiceStatus}`);
      }
    } else {
      console.log(`E-Invoice PDF Button hidden. E-Invoice consent indicator: ${einvoiceConsentInd}`);
    }
  }

  showCertificatePdf(status, cnoteType): any {
    const validEndorsementTypes = ['COE', 'XP', 'ENDT04', 'ENDT12', 'ENDT34', 'ENDT23', 'ENDT24', 'ENDT25'];

    let showButton = true;

    if (status !== 'PRINTED' && status !== 'SUBMITTED') {
      console.log(`Condition failed: Status is '${status}', expected 'PRINTED or SUBMITTED'.`);
      showButton = false;
    }

    if (!validEndorsementTypes.includes(cnoteType)) {
      console.log(`Condition failed: endtType '${cnoteType}' is not valid.`);
      showButton = false;
    }

    console.log(`isShowCertificatePDFBtn: ${showButton}`);
    return showButton;
  }

  showRequestCancellation(cngeNote: any, checkAgent: boolean): any {
    const {
      cnoteType, jpjStatus, isPrintCNote, endtNo
    } = cngeNote;

    let hideButton = false;
    let isAgentLogin = !!this.userInfo.agent && this.userInfo.agent === true;
    const allowedEndorsements = ['OTTEMP', 'COE', 'XP', 'XS'];

    if (endtNo && endtNo != '') {
        console.log("Request Cancel Button is hidden because endtNo has a value:", endtNo);
        hideButton = true;
    } else if (jpjStatus === 'SENT') {
        console.log("Request Cancel Button is hidden because JPJ status is 'SENT'.");
        hideButton = true;
    } else if (checkAgent && !isAgentLogin) {
        console.log("Request Cancel Button is hidden because the user is not an agent.");
        hideButton = true;
    } else if (isPrintCNote && !allowedEndorsements.includes(cnoteType)) {
        console.log(
            "Request Cancel Button is hidden because cnoteType is not in the allowed endorsements list.",
            "cnoteType:", cnoteType
        );
        hideButton = true;
    }

    return !hideButton;
  }

  async getLatestEndtNo(): Promise<string | null> {
    const state: any = await this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(this.cngeNote.contractId, "SUMMARY")).toPromise();
  
    if (state) {
      const cngeNote = this.store.selectSnapshot<any>(
        (state) => state.SatMotorState.viewQuotation
      );
  
      if (cngeNote) {
        console.log("Current Endt No: " + (cngeNote.endtNo ? cngeNote.endtNo : 'null'));
        return cngeNote.endtNo ? cngeNote.endtNo : null;
      }
    }
  
    return null;
  }

  showUpdatePayment(cngeNote: any): any {
    const isCallCenter = this.userInfo.callCenter;
    const userId = this.userInfo.userId;
    const { issueOnBehalf, issueOnEndorsement } = this.userInfo;
    const {
      cnoteStatus, issueCngeNote,
      issueEndorsement, createBy
    } = cngeNote;

    let hideButton = false;

    if(!this.isSSUser) {
      hideButton = true;
      return !hideButton;
    }

    if (!isCallCenter ||
      cnoteStatus === "CANCELLED" ||
      (cnoteStatus === "PENDING" && (issueOnBehalf === true || issueOnEndorsement === true) && createBy !== userId)) {
      hideButton = true;
    }

    return !hideButton;
  }

  async openRequestCancellationPopUp(): Promise<void> {

    let latestEndtDetails = await this.getLatestEndtDetails(this.cngeNote.contractId);

    let data = {
      summaryData: latestEndtDetails,
      isEndorsement: true
    }

    this.requestCancellationModal = this.dialogService.open(RequestCancellationComponent, {
      showCloseIcon: false,
      disableClose: true,
      autoFocus: false,
      data: data
    });

    this.requestCancellationModal.afterClosed().subscribe(async result => {
      if(result) {
        let payload = {
          cancelRemarks: result.data.cancelRemarks,
          cancelReasonCode: result.data.cancellationReason,
          contractId: this.cngeNote.contractId,
          operator: this.userInfo.userId
        };

        const endtNo = await this.getLatestEndtNo();

        if (result.isCancelAndReplace) {
          if (endtNo) {
            this.showOkMessage('Endorsement generated, cancellation is not allowed.');
          } else {
            this.store.dispatch(new CANCEL_REPLACE(payload)).subscribe((state) => {
              let cancellationRes = state.SatMotorState.data.cancellationRes;
              let ncdPayload = {
                productType: cancellationRes?.cngeNoteDto?.productCode,
                vehicleUse: cancellationRes?.cngeNoteDto?.riskList?.[0].vehicleUse,
                vehicleNo: cancellationRes?.cngeNoteDto?.riskList?.[0].vehicleNo,
                previousNcdVehicle: cancellationRes?.cngeNoteDto?.riskList?.[0].prevNcdVeh,
                chassisNo: cancellationRes?.cngeNoteDto?.riskList?.[0].vehicleChassis,
                idType: cancellationRes?.cngeNoteDto?.clientPartner?.idType1,
                idNo1: cancellationRes?.cngeNoteDto?.clientPartner?.idValue1,
                idNo2: cancellationRes?.cngeNoteDto?.clientPartner?.idValue2
              };
              this.store.dispatch(new GET_NCD_ENQUIRY(ncdPayload)).subscribe((state) => {
                let ncdInfo = state.SatMotorState.ncdEnquiryDetails;
                if (ncdInfo) {
                  let ncdPercentage;
                  let ncdEffDate;
                  const currPctExpDate = new Date(ncdInfo.currPctExpDate);
                  const nextNcdPctEffDate = new Date(ncdInfo.nextNcdPctEffDate);
                  const todaysDate = new Date(this.cngeNote.effectiveDate);

                  if (cancellationRes?.cngeNoteDto) {
                    ncdEffDate = cancellationRes?.cngeNoteDto?.effectiveDate;
                    if (cancellationRes?.cngeNoteDto?.cnoteType === 'NWNN')
                      ncdEffDate = new Date().toISOString().slice(0, 10);
                  }

                  if (currPctExpDate < todaysDate || todaysDate >= nextNcdPctEffDate) {
                    ncdPercentage = ncdInfo.nextNcdPct;
                  } else {
                    ncdPercentage = ncdInfo.currNcdPct;
                  }

                  cancellationRes = {
                    ...cancellationRes,
                    cngeNoteDto: {
                      ...cancellationRes.cngeNoteDto,
                      riskList: [{
                        ...cancellationRes.cngeNoteDto.riskList[0],
                        prevNcdEffDate: ncdInfo.currPctEffDate,
                        prevNcdExpDate: ncdInfo.currPctExpDate,
                        ncdEffDate: ncdEffDate,
                        nextNcdEffDate: ncdInfo.nextNcdPctEffDate,
                        nextNcdPct: ncdPercentage
                      }]
                    }
                  }
                }
                
                this.store.dispatch(new CALCULATE_ENDT_PREMIUM({ ...cancellationRes, operator: this.userInfo.userId })).subscribe(state => {
                  const coveragePremium = state.SatMotorState.endorsement?.step2?.endorsementDetails?.coveragePremium?.data;
                  this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE({ ...cancellationRes, cngeNoteDto: coveragePremium.cngeNoteDto })).subscribe(state => {
                    this.router.navigate(['endorsement/summary']);
                  });
                });
              });
            });
          }
        } else {
          if (endtNo) {
            this.showOkMessage('Endorsement generated, cancellation is not allowed.');
          } else {
            if(this.cngeNote.isPrintQuotation) {
              this.store.dispatch(new CANCEL_QUOTATION(payload)).subscribe(state => {
                let cancellationRes = state.SatMotorState.data.cancellationRes;
                if(cancellationRes) {
                  this.searchEndorsementByContractId(this.cngeNote.contractId);
                }
              });
            } else {
              this.store.dispatch(new CANCEL_COVER_NOTE(payload)).subscribe(state => {
                let cancellationRes = state.SatMotorState.data.cancellationRes;
                if(cancellationRes) {
                  this.searchEndorsementByContractId(this.cngeNote.contractId);
                }
              });
            }
          }
        }
      }
    });
  }

  performEndtVehicleSearch(vehicleNo) {
    if (vehicleNo != "") {
      const param = {
        "cngeNote": {
          "productType": "MT",
          "vehicleNo": vehicleNo
        }
      };

      this.store.dispatch(new SEARCH_ENDT_VEHICLE(param)).subscribe((res) => {
        let endtError = (res && res.SatMotorState?.endorsement?.step1?.endtVehicleSearchError) ?? null;
        let endtPolicy = (res && res.SatMotorState?.endorsement?.step1?.endtVehicleData) ?? null;

        if (endtPolicy && endtPolicy.mkagAgent) {
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: 'MT', agentCode: endtPolicy.mkagAgent.agentCode })).subscribe(state => {
            this.populateEndtStateData();
          });
        }

        if (endtError && endtError.message) {
          console.log("message: " + endtError.message);
          this.showOkMessage(endtError.message);
        }
      });
    }
  }

  populateEndtStateData() {
    this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(null)).subscribe(state => {
      this.router.navigate(["/endorsement/summary"]);
    });
  }

  updateQuotation() {

    if (this.isCCentric) {
      const getCCentricOpportunityInfoParam = {
        "opportunityId": this.queryParams.opportunityId,
        "action": "SUMMARY-UPDATE"
      };
      this.store.dispatch(new UPDATE_QUOTATION_GET_CCENTRIC_OPPORTUNITY_INFO(getCCentricOpportunityInfoParam)).subscribe((stateLevel1) => {
        let updateQuotationDetails = stateLevel1.SatMotorState.updateQuotation.cngeNoteDto;
        if (updateQuotationDetails) {
          this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: this.endtPolicy.productType, agentCode: this.endtPolicy.mkagAgent.agentCode })).subscribe((stateLevel2) => {
            
            let patchedLatestPremiumCalculation = this.latestPremiumCalculation;
            patchedLatestPremiumCalculation = {
              ...patchedLatestPremiumCalculation,
              riskList: [{
                ...patchedLatestPremiumCalculation?.riskList?.[0],
                ...(updateQuotationDetails?.riskList?.[0]?.vehModelNvic && { vehModelNvic: updateQuotationDetails.riskList?.[0]?.vehModelNvic }),
                engineType: updateQuotationDetails.riskList?.[0]?.engineType
              }],
            };

            if (updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage) {

              let coverDto;
              if (updateQuotationDetails?.riskList?.[0]?.coverList?.[0].subCovPackage === 'HSBC_0100') {  //added for BMW HSBC package
                coverDto = {
                  extCovPackageSelected: patchedLatestPremiumCalculation?.riskList?.[0]?.coverList?.[0].subCovPackage
                }
              } else {
                coverDto = {
                  ...patchedLatestPremiumCalculation.riskList[0].coverList[0].coverDto,
                  extCovPackageSelected: updateQuotationDetails.riskList[0].coverList[0].subCovPackage
                }
              }

              patchedLatestPremiumCalculation = {
                ...patchedLatestPremiumCalculation,
                riskList: [
                  {
                    ...patchedLatestPremiumCalculation.riskList[0],
                    coverList: [
                      {
                        ...patchedLatestPremiumCalculation.riskList[0].coverList[0],
                        subCovPackage: updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackage,
                        subCovPackageDesc: updateQuotationDetails?.riskList?.[0]?.coverList?.[0]?.subCovPackageDesc,
                        coverDto: coverDto,
                      }
                    ]
                  }
                ]
              };
            }
            
            let endtPremiumCalculationPayload = {
              cngeNoteDto: patchedLatestPremiumCalculation,
              htgePol: this.htgePol,
              operator: this.userInfo.userId
            };
            this.store.dispatch(new ENDT_CALCULATE_PREMIUM_SUMMARY(endtPremiumCalculationPayload)).subscribe((stateLevel3) => {
              let premiumResponse = {
                ...stateLevel3.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data,
                htgePol: this.htgePol
              };
              this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(premiumResponse)).subscribe((stateLevel4) => {
                this.router.navigate(["/endorsement/summary"]);
              });
            });
          });
        }
      });
    } else {
      //this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
      //this.performEndtVehicleSearch(this.endtPolicy.riskList[0].vehicleNo);

      this.store.dispatch(new ENDT_GET_UPDATE_QUOTATION_DETAILS(this.endtPolicy.contractId, "SUMMARY")).subscribe((state) => {
        let updateQuotationDetails = state.SatMotorState.updateQuotation.cngeNoteDto;
        if (updateQuotationDetails) {
          this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: this.endtPolicy.productType, agentCode: this.endtPolicy.mkagAgent.agentCode })).subscribe((state) => {
            if(this.opportunityId || this.userInfo.callCenter) {

              if (updateQuotationDetails?.riskList[0]?.coverList[0]?.subCovPackage) {
                updateQuotationDetails = {
                  ...updateQuotationDetails,
                  riskList: [
                    {
                      ...updateQuotationDetails.riskList[0],
                      coverList: [
                        {
                          ...updateQuotationDetails.riskList[0].coverList[0],
                          coverDto: {
                            ...updateQuotationDetails.riskList[0].coverList[0].coverDto,
                            extCovPackageSelected: updateQuotationDetails.riskList[0].coverList[0].subCovPackage
                          }
                        }
                      ]
                    }
                  ]
                };
              }
              let endtPremiumCalculationPayload = {
                // ...policyData,
                cngeNoteDto: updateQuotationDetails,
                htgePol: this.htgePol,
                operator: this.userInfo.userId
              };
              this.store.dispatch(new ENDT_CALCULATE_PREMIUM_SUMMARY(endtPremiumCalculationPayload)).subscribe((state) => {
                let premiumResponse = {
                  ...state.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data,
                  htgePol: this.htgePol
                };
                this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(premiumResponse)).subscribe((state) => {
                  this.router.navigate(["/endorsement/summary"]);
                });
              });
            } else {
              this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(null)).subscribe(state => {
                this.router.navigate(["/endorsement/summary"]);
              });
            }


            // this.store.dispatch(new COPY_CNGE_INFO_VIEW_QUOTATION(updateQuotationDetails)).subscribe(state => {

            //   this.router.navigate(["/issuance/summary"]);

            // });
          });
        }
      });
    }

  }

  async checkEmailDocument() {

    const endtNo = await this.getLatestEndtNo();

    if (endtNo) {
      this.emailDocument();
    } else {
      this.dialogService.open(this.endtNotExist, {
        ariaLabel: "A simple dialog",
        showCloseIcon: false,
        disableClose: true,
        width: '95%',
        maxWidth: '400px',
      });
    }

  }

  emailDocument() {
    this.emailDocumentModal = this.dialogService.open(EmailDocumentComponent, {
      ariaLabel: "A simple dialog",
      showCloseIcon: false,
      disableClose: true,
      width: "95%",
      maxWidth: "900px",
      maxHeight: "95vh",
      data: { popup_type: 'emaildocument' },
    });
  }

  redirectBack() {
    this.redirectToSummary();
  }

  redirectToSummary() {
    this.store.dispatch(new GET_SWITCH_SITE("SUMMARY_SYS_URL")).subscribe(state => {
      window.location.href = state.SatMotorState.data.switchSiteUrl;
    });
  }

  downloadPDF(type) {
    let payload = {
      operator: this.userInfo.userId,
      contractId: this.cngeNote.contractId,
      type: type
    };

    this.store.dispatch(new DOWNLOAD_PDF(payload)).subscribe(() => {
    });
  }

  checkLatestEndtNo(type) {
    this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(this.cngeNote.contractId, "SUMMARY")).subscribe((state) => {
      let cngeNote = this.store.selectSnapshot<any>(state => state.SatMotorState.viewQuotation);
      
      if (cngeNote) {
        console.log("Current Endt No: " + (cngeNote.endtNo ? cngeNote.endtNo : 'null'));
        
        if (cngeNote.endtNo) {
          this.endtPolicy = cngeNote;
          this.checkDownloadPDF(type);
        } else {
          this.dialogService.open(this.endtNotExist, {
            ariaLabel: "A simple dialog",
            showCloseIcon: false,
            disableClose: true,
            width: '95%',
            maxWidth: '400px',
          });
        }
        
      }
    });
  }

  checkDownloadPDF(type) {
    let endtType = this.endtPolicy.cnoteType;
    const payload: any = {
      operator: this.userInfo.userId,
      contractId: this.cngeNote.contractId,
      type: type,
    };

    if (this.endtPolicy.cnoteType === 'XP' || type === 'endorsementCI' || 
      (type === 'endorsement' && endtType !== 'ENDT17' && endtType !== 'ENDT18')) {
      this.store.dispatch(new DOWNLOAD_PDF(payload));

    } else {
      this.clauseMsgModal = this.dialogService.open(ClauseMessageComponent, {
        disableClose: true,
        width: '450px',
        maxWidth: '450px',
      });
      this.clauseMsgModal.afterClosed().subscribe(result => {
        payload.printClauseInd = (result === 'Y');
        this.store.dispatch(new DOWNLOAD_PDF(payload));
      });
    }

  }

  sendToJPJ() {
    let resetPayload = {
      isEndorsement: true
    };

    this.endtPolicy = {
      ...this.endtPolicy,
      cnoteDate: new Date().toISOString().substring(0, 10),
      issueBy: this.userInfo.userId,
      nettPremium: this.endtPolicy.riskList[0].coverList[0].nettPremium
    };

    let payload = {
      policy: this.endtPolicy,
      endtType: this.endtPolicy.cnoteType,
      userId: this.userInfo.userId
    }

    this.store.dispatch(new RESET_GENERATE_QUOTATION_AND_SEND_TO_JPJ(resetPayload));
    this.store.dispatch(new GENERATE_ENDORSEMENT(payload)).subscribe(() => {
      let response = this.store.selectSnapshot<any>(state => state.SatMotorState.endorsement?.step3?.sendToJPJ ?? null);

      if (response && response.data && response.success) {
        this.searchEndorsementByContractId();
      } else {
        this.showResponseError(response);
      }
    });
  }

  showResponseError(response: any) {
    console.log('showResponseError response:' + response);
    let message = (response.message && response.message != '') ? response.message : (response.errorCode && response.errorCode != '') ? response.errorCode : null;

    if (message) {
      this.showOkMessage(message);
    }
  }

  showOkMessage(message) {
    this.okMessageModal = this.dialogService.open(OkMessageComponent, {
      disableClose: true,
      width: '400px',
      data: {
        message: message
      }
    });
  }

  uploadDocument() {
    let dialogConfig = {
      showCloseIcon: false,
      disableClose: true,
      width: "80%",
      maxWidth: "80vw",
      maxHeight: "95vh",
      data: {
        contractId: this.endtPolicy.contractId
      }
    };

    this.dialogRef = this.dialogService.open(UploadDocumentComponent, dialogConfig);
  }
  
  getAdminRemarks(referAdminRemarkList: any) {
    let list = [];
    referAdminRemarkList.forEach((remark, index) => {
        let combinedString = `${index + 1}. ${remark.createdBy} ${this.getFormattedDateTime(remark.createDate)}: ${remark.referAction}`;
        list.push(combinedString);
    });
    return list;
  }

  addRemarks() {
    this.remarksModal = this.dialogService.open(RemarksComponent, {
      showCloseIcon: false,
      disableClose: true,
      data: {
        title: "Enter Remarks",
        primaryButtonLabel: "SUBMIT"
      }
    });

    this.remarksModal.afterClosed().subscribe(result => {
      if(result) {
        const data = {
          contractId : this.endtPolicy.contractId,
          remark: result.remarks,
          operator: this.userInfo.userId,
          isViewQuotation: true
        };

        this.store.dispatch(new SAVE_REFERRAL_REMARKS(data)).subscribe(state => {
          let referRemarkList = state.SatMotorState.viewQuotation?.cngeNote?.referRemarkList ?? null;
          if (referRemarkList) {
            this.remarksInfo = {
              ...this.remarksInfo,
              referral: referRemarkList
            }
          }
        });
      }
    });
  }

  getFormattedDate(dateVal) {
    if (!dateVal) {
      return dateVal;
    }

    return moment(dateVal, 'YYYY-MM-DD').format('DD/MM/YYYY');
  }

  getFormattedDateTime(dateString: string): string {
    if(!dateString){
      return dateString;
    }

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    const formattedHours = hours % 12 || 12;

    return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
  }

  hasCoverNoteGenerated() {
    return this.cngeNote.cnoteNo && this.cngeNote.cnoteNo != '';
  }

  getPaymentData(data) {
    this.payment = {
      receiptNo: data.receiptNo,
      transactionDate: data.cnoteDate,
      eCoverNoteNo: data.cnoteNo,
      vehicleNo: data?.riskList[0]?.vehicleNo,
      accountCode: data.mkagAgent.agentCode,
      insuredName: data.clientPartner.clientName,
      totalPremiumDue: data?.riskList[0]?.coverList[0]?.premiumDue,
    };

    this.paymentList = data.paymentList ? data.paymentList : [];

    this.roadTaxPayable = {
      roadTax: data.roadTax,
      myegFees: data.myegFees,
      courierFees: data.courierFees,
      merchantCharges: data.merchantCharges,
      totalRoadTaxPayable: data.totalRoadTaxPayable
    };

    this.paymentInformation = {
      totalPayable: data.totalPayable,
      totalPayableRounded: data.totalPayableRounded,
      totalPaid: data.totalPaid,
      balancePayable: data.balancePayable
    };
  }

  updatePayment() {
    if (this.isCCentric) {
      const getCCentricOpportunityInfoParam = {
        "opportunityId": this.queryParams.opportunityId,
        "action": "SUMMARY"
      };
      this.store.dispatch(new GET_CCENTRIC_ENDT_OPPORTUNITY_INFO(getCCentricOpportunityInfoParam)).subscribe((state) => {
        let updatePaymentDetails = state.SatMotorState.viewQuotation;
        if (updatePaymentDetails) {
          this.store.dispatch(new SET_UPDATE_PAYMENT_IND(true));
          this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: updatePaymentDetails.productType, agentCode: updatePaymentDetails.mkagAgent.agentCode })).subscribe((stateLevel1) => {
            let endtPremiumCalculationPayload = {
              // ...policyData,
              cngeNoteDto: updatePaymentDetails,
              htgePol: this.htgePol,
              operator: this.userInfo.userId
            };

            if (endtPremiumCalculationPayload?.cngeNoteDto?.riskList[0]?.coverList[0]?.subCovPackage) {
              endtPremiumCalculationPayload = {
                ...endtPremiumCalculationPayload,
                cngeNoteDto: {
                  ...endtPremiumCalculationPayload?.cngeNoteDto,
                  riskList: [
                    {
                      ...endtPremiumCalculationPayload?.cngeNoteDto.riskList[0],
                      coverList: [
                        {
                          ...endtPremiumCalculationPayload?.cngeNoteDto.riskList[0].coverList[0],
                          coverDto: {
                            ...endtPremiumCalculationPayload?.cngeNoteDto.riskList[0].coverList[0].coverDto,
                            extCovPackageSelected: endtPremiumCalculationPayload?.cngeNoteDto.riskList[0].coverList[0].subCovPackage
                          }
                        }
                      ]
                    }
                  ]
                }
              };
            }

            this.store.dispatch(new ENDT_CALCULATE_PREMIUM_SUMMARY(endtPremiumCalculationPayload)).subscribe(stateLevel2 => {
              let latestCoveragePremium = stateLevel2?.SatMotorState?.endorsement?.step2?.endorsementDetails?.coveragePremium?.data;
              let hasSubCovPackageList = stateLevel2?.SatMotorState?.endorsement?.step2?.endorsementDetails?.coveragePremium?.data?.cngeNoteDto?.riskList?.[0]?.coverList?.[0].coverDto?.subCovPackageList;
              let previousSubCoverList = this.htgePol?.riskList?.[0].coverList?.[0].subCoverList;
              let hasWaiver = previousSubCoverList?.some(obj => (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') && obj.subCoverPrem > 0);

              if (hasWaiver || (hasSubCovPackageList && hasSubCovPackageList.length > 0)) {
                let latestSubCovList = latestCoveragePremium?.cngeNoteDto?.riskList?.[0]?.coverList?.[0]?.coverDto?.subCovList;

                if (hasWaiver) {
                  latestSubCovList = latestSubCovList?.map(obj => {
                    if (obj.subCoverCode === 'A200' || obj.subCoverCode === 'M02') {
                      return { ...obj, selected: true }
                    }
                    return obj;
                  })
                }

                endtPremiumCalculationPayload = {
                  ...endtPremiumCalculationPayload,
                  cngeNoteDto: {
                    ...endtPremiumCalculationPayload.cngeNoteDto,
                    riskList: [{
                      ...endtPremiumCalculationPayload.cngeNoteDto.riskList[0],
                      coverList: [{
                        ...endtPremiumCalculationPayload.cngeNoteDto.riskList[0].coverList[0],
                        coverDto: {
                          ...endtPremiumCalculationPayload.cngeNoteDto.riskList[0].coverList[0].coverDto || {},
                          subCovList: latestSubCovList || [],
                          subCovPackageList: hasSubCovPackageList
                        }
                      }]
                    }]
                  }
                };

                this.store.dispatch(new ENDT_CALCULATE_PREMIUM_SUMMARY(endtPremiumCalculationPayload)).subscribe(stateLevel3 => {
                  let premiumResponse2 = {
                    ...stateLevel3.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data,
                    htgePol: this.htgePol
                  };
                  this.store.dispatch(new ENDT_SET_UPDATE_PAYMENT_DATA(premiumResponse2));
                  this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(premiumResponse2)).subscribe((stateLevel4) => {
                    this.router.navigate(["/endorsement/summary"]);
                  });
                });
              } else {

                let premiumResponse = {
                  ...stateLevel2.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data,
                  htgePol: this.htgePol
                };

                this.store.dispatch(new ENDT_SET_UPDATE_PAYMENT_DATA(premiumResponse));
                this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(premiumResponse)).subscribe((stateLevel3) => {
                  this.router.navigate(["/endorsement/summary"]);
                });
              }


            });
          });
        }
      });
    }else {
      this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(this.queryParams.contractId, "SUMMARY")).subscribe((state) => {
        let updatePaymentDetails = state.SatMotorState.viewQuotation;
        let updatePaymentHtgePol = state.SatMotorState.viewHtgePol;
        if (updatePaymentDetails) {
          this.store.dispatch(new SET_UPDATE_PAYMENT_IND(true));
          this.store.dispatch(new SET_ACTION(ACTIONS.ENDT));
          this.store.dispatch(new GET_PRODUCT_LIST({ lob: updatePaymentDetails.productType, agentCode: updatePaymentDetails.mkagAgent.agentCode })).subscribe((stateLevel1) => {
            let endtPremiumCalculationPayload = {
              // ...policyData,
              cngeNoteDto: {
                ...updatePaymentDetails,
                riskList: [{
                  ...updatePaymentDetails.riskList[0],
                  coverList: [{
                    ...updatePaymentDetails.riskList[0].coverList[0],
                    coverDto: {
                      ...updatePaymentDetails.riskList[0].coverList[0].coverDto,
                      checkPremCalc: false
                    }
                  }]
                }],
              },
              htgePol: updatePaymentHtgePol,
              operator: this.userInfo.userId
            };
            this.store.dispatch(new ENDT_CALCULATE_PREMIUM_SUMMARY(endtPremiumCalculationPayload)).subscribe(stateLevel2 => {
              let premiumResponse = {
                ...stateLevel2.SatMotorState.endorsement.step2.endorsementDetails.coveragePremium.data,
                htgePol: this.htgePol
              };
              this.store.dispatch(new ENDT_SET_UPDATE_PAYMENT_DATA(premiumResponse));
              this.store.dispatch(new COPY_CNGE_TO_ENDORSEMENT_STATE(premiumResponse)).subscribe((stateLevel3) => {
                this.router.navigate(["/endorsement/summary"]);
              });
            });
          });
        }
      });
    }
  }

  getLatestEndtDetails(contractId) {
    return new Promise((resolve) => {
      this.store.dispatch(new GET_QUOTATION_DETAIL_ENDT(contractId, "SUMMARY")).subscribe((state) => {
        let latestEndtDetails = state.SatMotorState.viewQuotation;
        resolve(latestEndtDetails);
      });
    });
  }

  get updateQuotationNaming() {
    if(this.userInfo.callCenter) {
      return this.cngeNote.cnoteType === 'COE' || this.cngeNote.cnoteType === 'XP' ? 'UPDATE E-QUOTATION / SEND TO JPJ' : 'UPDATE E-QUOTATION / GENERATE ENDORSEMENT';
    }else {
      return 'UPDATE E-QUOTATION';
    }
  }

  get coverNoteNumber() {
    return this.cngeNote.cnoteNo;
  }

  get quotationNo() {
    return this.cngeNote?.proposalNo;
  }

  get isSSUser() {
    if(this.userInfo.callCenter && this.userInfo.callCentreType == "S") {
      return true;
    }else {
      return false;
    }
  }

  isDisableRequestCancel(): boolean {
    return this.validateAccess(AccessConfig.CANCEL_ENDORSEMENT);
  }

  isDisableUpdatePayment(): boolean {
    return this.validateAccess(AccessConfig.UPDATE_PAYMENT);
  }

  isDisableSchedulePDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF_SCHEDULE);
  }

  isDisableQuotationPDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF);
  }

  isDisableCertificatePDF(): boolean {
    return this.validateAccess(AccessConfig.ENDORSEMENT_PDF_CERTIFICATE);
  }

  validateAccess(config: ButtonAccessConfig): boolean {
    return this.accessService.checkAccess(config);
  }
}
